module.exports = __webpack_public_path__ + "static/media/scene5_sama2.7a475b94.wav";